import { type CoreFiltersFrontendState } from '@autone/redux/core';
import { createContext, type PropsWithChildren, useContext } from 'react';

import { type AdvancedFiltersPublicState } from '../../advanced-filters';

type AutoneReadonlyFilterChipContextValue = {
  coreFiltersFrontendState: CoreFiltersFrontendState;
  advancedFiltersState: AdvancedFiltersPublicState;
};

export const AutoneReadonlyFilterChipContext =
  createContext<AutoneReadonlyFilterChipContextValue | null>(null);

export const AutoneReadonlyFilterChipContextProvider = ({
  children,
  coreFiltersFrontendState,
  advancedFiltersState,
}: PropsWithChildren<AutoneReadonlyFilterChipContextValue>) => {
  return (
    <AutoneReadonlyFilterChipContext.Provider
      value={{ coreFiltersFrontendState, advancedFiltersState }}
    >
      {children}
    </AutoneReadonlyFilterChipContext.Provider>
  );
};

export const useAutoneReadonlyFilterChipContext = () => {
  const context = useContext(AutoneReadonlyFilterChipContext);
  if (!context) {
    throw new Error(
      'useAutoneReadonlyFilterChipContext must be used within a AutoneReadonlyFilterChipContextProvider',
    );
  }
  return context;
};
